

interface LoadingSpinnerProps {
    message?: string;
    size?: 'sm' | 'md' | 'lg';
    fullScreen?: boolean;
}

export function LoadingSpinner({
    message = 'Loading...',
    size = 'md',
    fullScreen = false
}: LoadingSpinnerProps) {
    const spinnerSize = size === 'sm' ? 'spinner-border-sm' : '';
    const style = size === 'lg' ? { width: '3rem', height: '3rem' } : {};

    const content = (
        <div className={`d-flex flex-column align-items-center justify-content-center ${fullScreen ? 'h-100' : ''}`}>
            <div className={`spinner-border text-primary ${spinnerSize}`} role="status" style={style}>
                <span className="visually-hidden">Loading...</span>
            </div>
            {message && <div className="mt-2 text-muted">{message}</div>}
        </div>
    );

    if (fullScreen) {
        return (
            <div className="position-fixed top-0 start-0 w-100 h-100 bg-body d-flex align-items-center justify-content-center" style={{ zIndex: 2000 }}>
                {content}
            </div>
        );
    }

    return content;
}
